<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useConfirm, useToast } from 'primevue'
import { usePushCampaignListStore } from '@/modules/push-campaign/stores/push-campaign.list.store.ts'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  cellConfig: {
    type: Object,
    default: () => ({}),
  },
  tableConfig: {
    type: Object,
    default: () => ({}),
  },
})

const confirm = useConfirm()
const toast = useToast()
const pushCampaignListStore = usePushCampaignListStore()

const handleGotoDetail = (e: MouseEvent) => {
  pushCampaignListStore.newTab({
    id: props.data.id,
    label: `#${props.data.id}`,
    active: true,
  })
}

const handleCancelCampaign = (e: MouseEvent) => {
  confirm.require({
    message: 'Bạn có muốn hủy chiến dịch này?',
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true,
    },
    acceptProps: {
      label: 'Đồng ý',
    },
    accept: async () => {
      try {
        await pushCampaignListStore.cancelCampaign(props.data.id)
        toast.add({ severity: 'success', summary: 'Thành công', detail: 'Hủy chiến dịch thành công', life: 3000 })
      } catch {
        toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Hủy chiến dịch thất bại', life: 3000 })
      }
    },
    reject: () => {},
  })
}
</script>

<template>
  <div class="flex gap-2">
    <button type="button" class="btn btn-cs flex items-center gap-1 whitespace-nowrap" @click="handleGotoDetail">
      <Icon icon="iconamoon:edit-duotone" />
      Chi tiết
    </button>
    <button
      v-if="props.data.status === 'scheduled'"
      type="button"
      class="btn btn-danger bg-hover-danger text-white flex items-center gap-1 whitespace-nowrap"
      @click="handleCancelCampaign"
    >
      <Icon icon="mdi:close-circle-outline" />
      Hủy kế hoạch
    </button>
  </div>
</template>
